"use client";

import Footer from "../navigation/Footer";
import LandingNavBar from "../navigation/LandingNav";
import LandingSideBar from "../navigation/LandingSideBar";

function LandingPageLayout({ children }) {
  return (
    <>
      {/* Sidebar */}
      <LandingSideBar />

      <main
        style={{
          backgroundImage: "url('/logo-bg.svg')",
          backgroundPosition: "cover",
          backgroundAttachment: "fixed",
          backgroundRepeat: "repeat",
        }}
      >
        <LandingNavBar />
        <main className="mt-20">{children}</main>
        <Footer />
      </main>
    </>
  );
}

export default LandingPageLayout;
